import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><filter id=\"a\" width=\"35\" height=\"35\" x=\"0\" y=\"0\" filterUnits=\"userSpaceOnUse\"><feOffset dy=\"3\"></feOffset><feGaussianBlur result=\"blur\" stdDeviation=\"3\"></feGaussianBlur><feFlood flood-opacity=\".161\"></feFlood><feComposite in2=\"blur\" operator=\"in\"></feComposite><feComposite in=\"SourceGraphic\"></feComposite></filter></defs><g filter=\"url(#a)\"><path fill-rule=\"evenodd\" d=\"M17.5 12.071a.911.911 0 1 1 .911-.911.911.911 0 0 1-.911.911zm-.607 6.679h1.214v-5.464h-1.214zM17.5 6a8.5 8.5 0 1 0 8.5 8.5A8.5 8.5 0 0 0 17.5 6z\"></path></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };